import { Box, Button, createMuiTheme, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, makeStyles, MuiThemeProvider, Paper, TextField, Tooltip } from '@material-ui/core'
import AddIcon from "@material-ui/icons/Add"
import AlertDialog from 'components/alert-dialog/AlertDialog'
import { HeaderBlock } from 'components/header-block/HeaderBlock'
import ListableCard from 'components/listable-card/ListableCard'
import { Loading } from 'components/loading/Loading'
import PageContainer from 'components/page-container/PageContainer'
import { DeleteModal } from 'containers/delete-modal/DeleteModal'
import GenericPickerModal from 'containers/generic-picker-modal/GenericPickerModal'
import MUIDataTable from 'mui-datatables'
import { default as React, Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { getDistributionsForUser, updateUserDistributors } from 'state/actions/DistributorsAction'
import { assignToRoutes, getUser } from 'state/actions/UserActions'
import { getRolesForUser, setRolesForUser } from 'state/actions/UserRoleActions'
import { RootState } from 'state/reducers/AppReducer'
import { FixMeLater } from 'types/FixMeLaterType'
import { getDistributors } from "../../../state/actions/DistributorsAction"
import { getRoutes } from "../../../state/actions/RouteActions"
import { removeFromRoutes } from "../../../state/actions/UserActions"
import { getUserRoles } from "../../../state/actions/UserRoleActions"

const useStyles = makeStyles({
    contentGrid: {
        margin: "30px"
    }
})

interface MatchParams {
    userId: string
}

interface Props extends RouteComponentProps<MatchParams> {
}

interface DistributorRule {
    FilterType: string,
    Field: string,
    Eq: boolean
}

interface Distributor {
    Active: boolean,
    ContainsAnyToken: string[],
    DisplayName: string,
    FilterRules: DistributorRule[],
    ModelType: string
    TokenField: string
    id: string
}

interface SimpleListItem {
    id: string,
    Name: string
}

interface MUIDataTableData {
    index: number,
    dataIndex: number
}

interface UserRole {
    id: string,
    displayName: string
}

interface User {
    email: string,
    id: string,
    name: string,
    routes: UserRoute[]
}

interface UserRoute {
    [id: string]: boolean
}

interface Route {
    id: string
}

export default function ViewUserPage(props: Props) {

    const user: User = useSelector<RootState, FixMeLater>(state => state.UserReducer.user)
    const routes: { [id: string]: Route } = useSelector<RootState, FixMeLater>(state => state.RouteReducer.routes)
    const currentUserDistributors: { [id: string]: Distributor } = useSelector<RootState, FixMeLater>(state => state.DistributorReducer.currentUserDistributors)
    const distributors: { [id: string]: Distributor } = useSelector<RootState, FixMeLater>(state => state.DistributorReducer.distributors)
    const currentRolesForUser: { [id: string]: UserRole } = useSelector<RootState, FixMeLater>(state => state.UserRoleReducer.currentRolesForUser)
    const userRoles: { [id: string]: UserRole } = useSelector<RootState, FixMeLater>(state => state.UserRoleReducer.userRoles)

    const [t, i18n] = useTranslation()
    const classes = useStyles()
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)
    const [loadingRoutes, setLoadingRoutes] = useState(false)
    const [loadingDistributors, setLoadingDistributors] = useState(false)
    const [loadingUserRoles, setLoadingUserRoles] = useState(false)

    const [routesToDelete, setRoutesToDelete] = useState([])
    const [distributorsToDelete, setDistributorsToDelete] = useState([])
    const [userRolesToDelete, setUserRolesToDelete] = useState<string[]>([])

    const [addNewRouteModalOpen, setAddNewRouteModalOpen] = useState(false)
    const [addDistributorModalOpen, setAddDistributorModalOpen] = useState(false)
    const [deleteDistributorModalOpen, setDeleteDistributorModalOpen] = useState(false)
    const [addRolesDialogOpen, setAddRolesDialogOpen] = useState(false)
    const [deleteRolesDialogOpen, setDeleteRolesDialogOpen] = useState(false)
    const [deleteAlertShowing, setDeleteAlertShowing] = useState(false)
    const [addRouteModalOpen, setAddRouteModalOpen] = useState(false)

    const [routeName, setRouteName] = useState("")


    useEffect(() => {
        const userId = props.match.params.userId;

        dispatch(getUser(userId, () => {
            setLoading(false)
        }))

        dispatch(getDistributionsForUser(userId, () => {
            setLoadingDistributors(false)
        }))

        dispatch(getRolesForUser(userId, () => {
            setLoadingUserRoles(false)
        }))
    }, [])

    useEffect(() => {
        console.log(user.routes)
    }, [user])

    function handleSetUserRoles(roles: string[]) {
        dispatch(setRolesForUser(user.id, roles, (success: boolean) => {
            setAddRolesDialogOpen(false)
            setDeleteRolesDialogOpen(false)
            if (success) {
                setLoadingUserRoles(true)

                dispatch(getRolesForUser(user.id, () => {
                    setLoadingUserRoles(false)
                }))
            }
        }))
    }

    function handleDistributorSelection(selectedDistributors: string[]) {
        const data = {
            UserId: user.id,
            DistributorIds: selectedDistributors
        }

        dispatch(updateUserDistributors(data, (success: boolean) => {
            setAddDistributorModalOpen(false)

            if (success) {
                setLoadingDistributors(true)

                dispatch(getDistributionsForUser(user.id, () => {
                    setLoadingDistributors(false)
                }))
            }
        }))
    }

    function handleDistributorDeletion(selectedDistributors: SimpleListItem[]) {
        const currentIds = Object.values(currentUserDistributors).map((item: Distributor) => item.id)
        const selectedDistributorsIds = selectedDistributors.map((item: SimpleListItem) => item.id);

        const data = {
            UserId: user.id,
            DistributorIds: currentIds.filter(value => !selectedDistributorsIds.includes(value))
        }

        dispatch(updateUserDistributors(data, (success: boolean) => {
            setDeleteDistributorModalOpen(false)
            if (success) {
                setDistributorsToDelete([])
                setLoadingDistributors(true)
                dispatch(getDistributionsForUser(user.id, () => {
                    setLoadingDistributors(false)
                }))
            }
        }));
    }

    function getDistributorList(distributorIds: string[]): SimpleListItem[] {
        if (distributorIds !== undefined) {
            return distributorIds.map((distributorId: string) => {
                const distributor: Distributor = distributors[distributorId];

                if (distributor !== undefined) {
                    return { id: distributor.id, Name: distributor.DisplayName };
                }

                return { id: distributorId, Name: t('common.unknown-deleted-data') };
            });
        }

        return [];
    }

    function getRouteList(routeIds: Route[]): SimpleListItem[] {
        if (routeIds !== undefined) {
            return routeIds.map((route: Route) => {

                return { id: route.id, Name: route.id };
            });
        }

        return [];
    }

    function deleteRoutesFromUser() {
        const userId = props.match.params.userId;
        const routeIds = routesToDelete;

        dispatch(removeFromRoutes(userId, routeIds, () => {
            setDeleteAlertShowing(false)
            setRoutesToDelete([])
        }));
    }

    function addRoutesToUser(routes: string[]) {
        const userId = props.match.params.userId;

        dispatch(assignToRoutes(userId, routes, () => {
            setAddRouteModalOpen(false)
            setAddNewRouteModalOpen(false)
        }))
    }

    function deleteRoutesModal() {
        const routes = routesToDelete !== null ? routesToDelete : [];

        let routeToDeleteName = "";

        if (routes.length > 1) {
            routeToDeleteName = t("user.count-routes", routes.length.toString())
        } else if (routes.length === 1) {
            routeToDeleteName = routes[0];
        }

        return (
            <AlertDialog
                title={t("user.remove-routes-question", { userName: user.name, routeToDeleteName: routeToDeleteName })}
                description={t("user.remove-routes-description")}
                options={[
                    {
                        label: t("common.cancel"),
                        action: () => setDeleteAlertShowing(false)
                    },
                    { label: t("common.delete"), action: () => deleteRoutesFromUser() }
                ]}
                isOpen={deleteAlertShowing}
            />
        );
    }

    function addRouteModal() {
        return (
            <GenericPickerModal
                handleCancel={() => setAddRouteModalOpen(false)}
                handleDone={routes => addRoutesToUser(routes)}
                open={addRouteModalOpen}
                selected={Object.keys(user?.routes || {})}
                handleSelection={() => { }}
                getAllData={(callback) => dispatch(getRoutes(callback))}
                title={t('user.add-user-to-routes')}
                data={getRouteList(Object.values(routes))}
                idField="id"
                valueField="Name"
                currentSelection={Object.keys(user?.routes || {})}
                searchTitle={t("route.routes")}
                searchField={"Name"}
                secondaryFields={["id"]}
            />
        );
    }

    function addDistributorModal() {
        return <GenericPickerModal
            handleCancel={() => setAddDistributorModalOpen(false)}
            handleDone={selectedDistributors => handleDistributorSelection(selectedDistributors)}
            open={addDistributorModalOpen}
            selected={Object.values(currentUserDistributors).map((item: Distributor) => item.id)}
            handleSelection={() => { }}
            getAllData={(callback) => dispatch(getDistributors(callback))}
            searchTitle="Search Distributor"
            title="Distributors"
            data={Object.values(distributors)}
            idField="id"
            valueField="DisplayName"
            currentSelection={Object.values(currentUserDistributors).map((item: Distributor) => item.id)}
        />
    }

    function deleteDistributorModal() {
        return <DeleteModal
            handleCancel={() => {
                setDeleteDistributorModalOpen(false)
                setDistributorsToDelete([])
            }}
            handleDone={(data: SimpleListItem[]) => {
                handleDistributorDeletion(data);
            }}
            data={getDistributorList(distributorsToDelete)}
            open={deleteDistributorModalOpen}
        />
    }

    function addNewRouteModal() {
        return (
            <Dialog
                fullWidth={true}
                open={addNewRouteModalOpen}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id="scroll-dialog-title">
                    {t('user.add-to-new-route')}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        id="outlined-name"
                        label={t("route.route-id")}
                        value={routeName}
                        onChange={(event) => setRouteName(event.target.value)}
                        margin="dense"
                        variant="outlined"
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setAddNewRouteModalOpen(false)}
                        color="secondary"
                    >
                        {t("common.cancel")}
                    </Button>
                    {/* <Button onClick={() => addNewRoute()} color="secondary">
                        {t("route.add-new-route")}
                    </Button> */}
                </DialogActions>
            </Dialog>
        );
    }

    function handleAddRoleToUser(roles: string[]) {
        handleSetUserRoles(roles)
    }

    function handleDeleteRolesFromUser() {
        const updatedRoles = Object.values(currentRolesForUser).filter((role: UserRole) => !userRolesToDelete.includes(role.id)).map((role: UserRole) => role.id)

        handleSetUserRoles(updatedRoles)
    }

    function addUserRoleModal() {
        return (
            <GenericPickerModal
                title={t("user.add-user-role")}
                searchTitle={t("user-role.user-roles")}
                idField="id"
                valueField="displayName"
                open={addRolesDialogOpen}
                data={Object.values(userRoles)}
                getAllData={(callback) => dispatch(getUserRoles(callback))}
                handleCancel={() => setAddRolesDialogOpen(false)}
                handleDone={(selected) => handleAddRoleToUser(selected)}
                selected={(Object.values(currentRolesForUser || {})).map((item: UserRole) => item.id)}
                currentSelection={(Object.values(currentRolesForUser || {})).map((item: UserRole) => item.id)}
                handleSelection={() => { }}
            />
        )
    }

    function deleteUserRoleModal() {
        const deleteList: SimpleListItem[] = userRolesToDelete.map(item => {
            const user = userRoles[item]
            if (user != null) {
                return { id: user.id, Name: user.displayName }
            }
            return { id: item, Name: t('common.unknown-deleted-data') }
        })

        return (
            <DeleteModal
                data={deleteList}
                handleCancel={() => setDeleteRolesDialogOpen(false)}
                handleDone={() => handleDeleteRolesFromUser()}
                open={deleteRolesDialogOpen}
            />
        )
    }

    function getUserRoleContent() {
        const options: object = {
            elevation: 0,
            filter: true,
            responsive: "vertical",
            rowsPerPage: 10,
            rowsPerPageOptions: [10, 25, 50],
            viewColumns: false,
            filterType: "checkbox",
            print: false,
            download: true,
            selectableRows: "multiple",
            rowHover: true,
            downloadOptions: {
                filename: "UserRoles.csv",
                separator: ",",
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowClick: (_: string[], rowMeta: { _: number, rowIndex: number }) => {
                const userRole: UserRole = Object.values(currentRolesForUser)[rowMeta.rowIndex]
                props.history.push(`/user-roles${userRole != null ? "/" : ""}${userRole?.id}`)

            },
            onRowsDelete: (rowsDeleted: { _: object, data: MUIDataTableData[] }, _: string[]) => {
                var toDelete: string[] = Object.values(rowsDeleted.data).map((item: MUIDataTableData) => {
                    const roles: UserRole[] = Object.values(currentRolesForUser || {})
                    if (roles != null) {
                        const role = roles[item.dataIndex] != null ? roles[item.dataIndex].id : ""
                        return role
                    }
                    return ""
                })


                if (toDelete == null) {
                    toDelete = []
                }

                setDeleteRolesDialogOpen(true)
                setUserRolesToDelete(toDelete.filter(item => item != ""))
                return false
            },
            customToolbar: () => {
                return (
                    <Fragment>
                        <Tooltip
                            title={t("user.assign-to-role") || ""}
                        >
                            <IconButton onClick={() => setAddRolesDialogOpen(true)}>
                                <AddIcon />
                            </IconButton>
                        </Tooltip>
                    </Fragment >
                );
            }
        }

        const columns = [
            {
                name: "displayName",
                label: t("common.name"),
                options: {
                    filter: true,
                    sort: true,
                }
            }
        ]

        const getMuiTheme = () => createMuiTheme({
            overrides: {
                MuiTableCell: {
                    body: {
                        color: "#4C73FF",
                        fontWeight: 400,
                        cursor: "pointer"
                    }
                }
            }
        })
        var showTheme = Object.values(currentRolesForUser || {}).length > 0

        return (
            <MuiThemeProvider theme={showTheme ? getMuiTheme() : {}}>
                <MUIDataTable
                    title={t("user-role.user-roles")}
                    data={Object.values(currentRolesForUser || {})}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
        )
    }

    function getContentGrid() {
        const routes: SimpleListItem[] =
            user.routes != null
                ? Object.keys(user.routes).map(key => {
                    return { Name: key, id: key };
                })
                : [];

        const distributors: SimpleListItem[] =
            currentUserDistributors != null
                ? Object.values(currentUserDistributors).map((value: Distributor) => {
                    return { Name: value.DisplayName, id: value.id };
                })
                : [];

        return (
            <Box className={classes.contentGrid}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <ListableCard
                            actionButton={[
                                <Button
                                    onClick={() => setAddRouteModalOpen(true)}
                                    variant="outlined"
                                    color="secondary"
                                >
                                    {t("user.assign-to-route")}
                                </Button>
                            ]}
                            title={t("user.assigned-to-routes")}
                            emptyPlaceholder={t("user.user-not-assigned-routes")}
                            handleDelete={(routesToDelete) => {
                                setDeleteAlertShowing(true)
                                setRoutesToDelete(routesToDelete)
                            }}
                            onClick={routeId =>
                                props.history.push(`/routes/${routeId}`)
                            }
                            data={routes}
                            isLoading={loadingRoutes}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <ListableCard
                            actionButton={[
                                <Button
                                    onClick={() => setAddDistributorModalOpen(true)}
                                    variant="outlined"
                                    color="secondary"
                                >
                                    {t("user.add-as-distributor")}
                                </Button>
                            ]
                            }
                            title={t("user.assigned-as-distributor")}
                            emptyPlaceholder={t("user.not-assigned-distributor")}
                            handleDelete={distributorsToDelete => {
                                setDeleteDistributorModalOpen(true)
                                setDistributorsToDelete(distributorsToDelete)
                            }}
                            onClick={distributorId =>
                                props.history.push(`/distributors/${distributorId}`)
                            }
                            data={distributors}
                            isLoading={loadingDistributors}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            {
                                loadingUserRoles ?
                                    <Loading /> :
                                    getUserRoleContent()
                            }
                        </Paper>

                    </Grid>
                </Grid>
            </Box >
        );
    }


    return (
        <Box>
            {loading ?
                <Loading />
                :

                <HeaderBlock
                    title={user.name}
                />
            }
            {deleteRoutesModal()}
            {addRouteModal()}
            {addNewRouteModal()}
            {addDistributorModal()}
            {deleteDistributorModal()}
            {addUserRoleModal()}
            {deleteUserRoleModal()}


            <PageContainer>
                {getContentGrid()}
            </PageContainer>
        </Box>
    )
}


